import FeatureMaterialDetails from "./feature-material-details";

function FeatureMaterialDetailsLandingPage() {
  return <FeatureMaterialDetails />;
}

export default FeatureMaterialDetailsLandingPage;
